import React from 'react';


type SpinnerProps = {
  fill: string
  className?: string;
}

// Taken (with modifications) from https://github.com/fakiolinho/react-loading/blob/master/lib/svg/loading-spin.svg
export const Spinner = (props: SpinnerProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' className={props.className}>
    <path
      fill={props.fill}
      opacity='.25'
      d='M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4'
    />
    <path fill={props.fill} d='M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z'>
      <animateTransform
        attributeName='transform'
        type='rotate'
        from='0 16 16'
        to='360 16 16'
        dur='0.8s'
        repeatCount='indefinite'
      />
    </path>
  </svg>
);
